import React from 'react'
import { withRouter } from 'react-router-dom'
import cn from 'classnames'

import QRCodeRegistration from '../components/QRCodeRegistration'
import useInterval from '../hooks/useInterval'

import styles from './RegisterDevice.module.scss'
import Button from '../components/Button'

const RegisterDevice = ({ history, className }) => {
  const classNames = cn(styles.registerDevice, className)

  useInterval(() => {
    history.push('/device-login')
  }, 30000)

  return (
    <div className={classNames}>
      <h1>Register Device</h1>
      <QRCodeRegistration className={styles.qrCodeRegistration} />
      <h2>Scan with camera</h2>
      <Button useMui className={styles.doneButton} onClick={() => history.push('/device-login')}>
        DONE
      </Button>
    </div>
  )
}

export default withRouter(RegisterDevice)
